export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";